"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const ModalWarningEdit = ({ cycleId, totalReviewer, stateData, source = 'cycles', onCloseModal }) => {
    const history = (0, react_router_dom_1.useHistory)();
    return (react_1.default.createElement(Modal_1.default, { minWidth: 400, customClass: "!max-w-[400px]", onClose: onCloseModal },
        react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)('Edit Cycle'), titleIcon: {
                name: 'icon-warning',
                color: 'var(--y-600)'
            }, onClose: onCloseModal }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("p", { className: "typography-paragraph px-[24px]" }, (0, HelperUtils_1.getObjectiveLocale)('Are you sure you want to edit this cycle configuration? Changes made will impact [total_reviewer] reviewees and might erase progress or final results that has been made.').replace('[total_reviewer]', totalReviewer))),
        react_1.default.createElement(Modal_1.default.Footer, { primaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Edit Cycle'),
                onClick: () => stateData === 'draft'
                    ? history.push(`/appraisals/cycles/${cycleId}/edit`)
                    : history.push(`/edit-active-cycles/${cycleId}?source=${source}`),
                dataCy: 'btn-edit-cycle'
            }, secondaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Cancel'),
                onClick: onCloseModal,
                dataCy: 'btn-cancel-edit'
            }, useBorder: false })));
};
exports.default = ModalWarningEdit;
